// how-to-start/utils/template-design.ts
//
// THE GENERATED STORY HAS TO CARRY THE TEMPLATE'S THEME.
//
// A deck built from a template is assembled with buildTemplateStoryFromSlides,
// which clones DEFAULT_STORY for everything that is not a slide -- including
// settings.designSystemV2. So the deck had the template's slides in the
// template's designs, and the DEFAULT theme's colours and fonts behind them.
//
// For a picked theme that never showed: the pick is a whole design system
// spread over the base, so the base did not matter. For "Use template's theme"
// it was the whole point: that option applies NOTHING on top, which only
// keeps the template's colours if the story already has them. It did not, and
// the option quietly produced the default theme -- blue #1571E7, which is not
// any template's colour.
//
// So the template's design system (and its custom colours, which the theme
// editor keeps beside it) is copied onto the generated story here, once, at
// the point the template's slides go in. A picked theme still wins later,
// exactly as before; the template's theme is now what it wins over.

type StoryLike = {
  settings: {
    designSystemV2: Record<string, unknown>;
    customColors?: string[];
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

export type TemplateDesignSource = {
  settings?: {
    designSystemV2?: Record<string, unknown>;
    customColors?: string[];
    [key: string]: unknown;
  };
  [key: string]: unknown;
} | null;

/**
 * Returns `story` with the template's design system layered over its own.
 * Keys the template does not set keep the story's value. Returns the same
 * object when the template carries no design system at all.
 */
export const withTemplateDesign = <T extends StoryLike>(
  story: T,
  template: TemplateDesignSource,
): T => {
  const design = template?.settings?.designSystemV2;
  if (!design || typeof design !== "object" || Object.keys(design).length === 0) {
    return story;
  }
  const customColors = template?.settings?.customColors;
  return {
    ...story,
    settings: {
      ...story.settings,
      designSystemV2: { ...story.settings.designSystemV2, ...design },
      ...(Array.isArray(customColors) && customColors.length > 0
        ? { customColors: [...customColors] }
        : {}),
    },
  };
};
